export const carManufacturersSlider = function() {
    const manufacturersContainer = document.querySelector('.jsManufacturersContainer');
    let manufacturersSwiper;
    if (!manufacturersContainer) return;
    swiperGenerator()

    function swiperGenerator() {
        const breakpoint = window.matchMedia('(min-width:768px)');
        const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
                if ( manufacturersSwiper !== undefined ) manufacturersSwiper.destroy( true, true );
                return;
            } else if ( breakpoint.matches === false ) {
                return enableSwiper();
            }
        };

        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
    }

    function enableSwiper() {
        manufacturersSwiper = new Swiper(manufacturersContainer, {
            slidesPerView: 5.5,
            spaceBetween: 15,
            watchOverflow: true,
            noSwiping: true,
            allowSlidePrev: true,
            allowSlideNext: true
        });
    }
}
